import styled from 'styled-components'
import { media } from 'styles/media'

export default styled.span`
  position: static;

  ${media.medium`
    font-size: 16px;
  `};

  ${media.large`
    font-size: 18px;
  `};
`
